export enum TagType {
    ONBEKEND = 0,
    VAK,
    LEERLING,
    LESDOEL,
}
